<div class="flex flex-col gap-6 w-full">
  <p class="text-xl">Reporting</p>

  <!-- Filters -->
  <div class="flex flex-row gap-4 items-end flex-wrap">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" style="min-width:220px">
      <mat-label>Employee</mat-label>
      <mat-select [disabled]="isLoadingEmployees()" [value]="selectedEmployeeNo()" (valueChange)="selectedEmployeeNo.set($event)">
        @for (emp of employees(); track emp.number) {
          <mat-option [value]="emp.number">{{ emp.displayName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width:150px">
      <mat-label>Month</mat-label>
      <mat-select [value]="selectedMonth()" (valueChange)="selectedMonth.set($event)">
        @for (m of months; track m.value) {
          <mat-option [value]="m.value">{{ m.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width:100px">
      <mat-label>Year</mat-label>
      <mat-select [value]="selectedYear()" (valueChange)="selectedYear.set($event)">
        @for (y of years; track y) {
          <mat-option [value]="y">{{ y }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-flat-button color="primary" [disabled]="!selectedEmployeeNo() || isSearching()" (click)="search()">
      Search
    </button>
  </div>

  <!-- Results -->
  @if (isSearching()) {
    <div class="flex justify-center items-center py-8">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (hasSearched()) {
    @if (lines().length === 0) {
      <p class="text-gray-400 py-4">No timesheet entries found for this selection.</p>
    } @else {
      <div class="flex flex-col gap-2">
        <p class="text-sm text-gray-500">{{ lines().length }} entries &mdash; {{ totalHours }} hours total</p>
        <div class="table-container">
          <table mat-table [dataSource]="lines()" class="w-full">

            <ng-container matColumnDef="entryNo">
              <th mat-header-cell *matHeaderCellDef class="w-24">Entry No.</th>
              <td mat-cell *matCellDef="let row" class="w-24 text-gray-500">{{ row.entryNo }}</td>
            </ng-container>

            <ng-container matColumnDef="timesheetNo">
              <th mat-header-cell *matHeaderCellDef class="w-32">Timesheet No.</th>
              <td mat-cell *matCellDef="let row" class="w-32 text-gray-500">{{ row.timesheetNo }}</td>
            </ng-container>

            <ng-container matColumnDef="activityDate">
              <th mat-header-cell *matHeaderCellDef class="w-32">Date</th>
              <td mat-cell *matCellDef="let row" class="w-32">{{ row.activityDate }}</td>
            </ng-container>

            <ng-container matColumnDef="projectNo">
              <th mat-header-cell *matHeaderCellDef class="w-48">Project</th>
              <td mat-cell *matCellDef="let row" class="w-48">
                <span class="block">{{ getProjectName(row.projectNo) }}</span>
                <span class="block text-xs text-gray-400">{{ row.projectNo }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="phaseNo">
              <th mat-header-cell *matHeaderCellDef class="w-48">Phase</th>
              <td mat-cell *matCellDef="let row" class="w-48">
                <span class="block">{{ getPhaseName(row.projectNo, row.phaseNo) }}</span>
                <span class="block text-xs text-gray-400">{{ row.phaseNo }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="taskNo">
              <th mat-header-cell *matHeaderCellDef class="w-36">Task</th>
              <td mat-cell *matCellDef="let row" class="w-36 text-gray-500">{{ row.taskNo }}</td>
            </ng-container>

            <ng-container matColumnDef="totalTime">
              <th mat-header-cell *matHeaderCellDef class="w-24 text-right">Hours</th>
              <td mat-cell *matCellDef="let row" class="w-24 text-right">{{ row.totalTime }}</td>
            </ng-container>

            <ng-container matColumnDef="billable">
              <th mat-header-cell *matHeaderCellDef class="w-24">Billable</th>
              <td mat-cell *matCellDef="let row" class="w-24">{{ row.billable ? 'Yes' : 'No' }}</td>
            </ng-container>

            <ng-container matColumnDef="zohoSynced">
              <th mat-header-cell *matHeaderCellDef class="w-28">Zoho</th>
              <td mat-cell *matCellDef="let row" class="w-28">
                @switch (getZohoSyncStatus(row.entryNo, row.timesheetNo)) {
                  @case ('synced') { <span class="text-green-600 text-sm">Synced</span> }
                  @case ('pending') { <span class="text-orange-500 text-sm">Pending</span> }
                  @default { <span class="text-gray-300 text-sm">—</span> }
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="comment">
              <th mat-header-cell *matHeaderCellDef>Comment</th>
              <td mat-cell *matCellDef="let row">{{ row.comment }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>
    }
  }
</div>
